import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const EditLink = styled.a`
  cursor: pointer;
`

const ProductRow = ({ productName, onEditClick }) => {
  return (
    <Fragment>
      <td>
        Loan Product
      </td>
      <td>
        {productName}
      </td>
      <td>
        <EditLink onClick={onEditClick}>Edit</EditLink>
      </td>
    </Fragment>
  )
}

ProductRow.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  productName: PropTypes.string.isRequired
}

export default ProductRow
